import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Grid, Box, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import LinkTwoTone from "@mui/icons-material/LinkTwoTone";
import PersonIcon from "@mui/icons-material/Person";
import { ModernLiquidTable, LiquidChip, LiquidIconButton } from "../../../components/modern-table";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import * as qs from "query-string";
import exportToExcel from "../../../utils/exportToExcel";
import { getEventByStatus } from "../../../api/event";


export default function ListEventPage() {
  const location = useLocation();
  const { userType, branch } = useSelector(({ auth }) => auth.user);
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const br = userType === 0 ? undefined : branch;

  React.useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const parsed = qs.parse(location.search);
        const data = await getEventByStatus(
          parsed.status !== "undefined" ? parsed.status : undefined,
          br
        );
        if (data) {
          setRows(data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [location.search, br]);

  const getEventStatus = (status) => {
    switch (status) {
      case 0:
        return "Baru";
      case 1:
        return "AKtif";
      case 2:
        return "Tamat";
      case 3:
        return "Tutup";
      default:
        return "Baru";
    }
  };

  const columns = [
    {
      field: "_rowNumber",
      title: "No",
      width: 50,
      render: (rowData) => <p>{rowData._rowNumber}</p>,
    },
    { field: "name", title: "Nama", width: 400 },
    { field: "venue", title: "Tempat" },
    {
      field: "eventStatus",
      title: "Status",
      render: (rowData) => {
        const status = rowData.eventStatus;
        let statusClass = 'default';

        switch(status) {
          case 1:
            statusClass = 'active';
            break;
          case 0:
            statusClass = 'pending';
            break;
          case 2:
            statusClass = 'success';
            break;
          case 3:
            statusClass = 'expired';
            break;
          default:
            statusClass = 'default';
        }

        return (
          <LiquidChip
            label={getEventStatus(status)}
            className={`status-${statusClass}`}
          />
        );
      }
    },
    {
      field: "actions",
      title: "Tindakan",
      render: (rowData) => (
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
          <Tooltip title="Lihat Peserta">
            <Link to={`/event/view?id=${rowData.id}`}>
              <LiquidIconButton size="small">
                <PersonIcon />
              </LiquidIconButton>
            </Link>
          </Tooltip>
          <Tooltip title="Lihat Pautan">
            <LiquidIconButton
              size="small"
              component="a"
              href={`https://sigmagema.com/event?id=${rowData.eventId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkTwoTone />
            </LiquidIconButton>
          </Tooltip>
          <Tooltip title="Edit">
            <Link to={`/event/edit?id=${rowData.id}`}>
              <LiquidIconButton size="small">
                <EditIcon />
              </LiquidIconButton>
            </Link>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const handleExport = (columns, data) => {
    const st = data.map((event) => {
      return {
        Nama_Event: event.name,
        Tempat: event.venue,
        Status: getEventStatus(event.eventStatus),
        Tarikh_Mula: event.startDate,
        Tarikh_Tamat: event.endDate,
        Penganjur: event.organizer,
        Jumlah_Peserta: event.participantCount || 0,
      };
    });
    exportToExcel(st);
  };

  const handleRefresh = async () => {
    const parsed = qs.parse(location.search);
    setLoading(true);
    try {
      const data = await getEventByStatus(
        parsed.status !== "undefined" ? parsed.status : undefined,
        br
      );
      if (data) {
        setRows(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Portlet>
      <PortletBody fluid={true}>
        <Grid className="p-3" container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                mb: 2,
                p: 2,
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
              }}
            >
              <span className="kt-section__sub">
                Senarai di bawah menrangkumi peristiwa yang telah dicatat melalui
                sistem sigma.
              </span>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <ModernLiquidTable
              columns={columns}
              data={rows}
              title={`Bilangan peristiwa: ${rows.length}`}
              loading={loading}
              onRefresh={handleRefresh}
              exportFunction={handleExport}
              emptyStateMessage="Tiada peristiwa untuk dipaparkan"
              options={{
                selection: false,
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [5, 10, 20, 50],
              }}
            />
          </Grid>
        </Grid>
      </PortletBody>
    </Portlet>
  );
}
